import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useFetch } from "@/lib/api";
import { ADSENSE_CLIENT, adsAllowedOn } from "@/components/AdSenseLoader";

function RailUnit({ slot }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && !ref.current.dataset.adsbygoogleStatus) {
      try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch { /* ad blocked */ }
    }
  }, [slot]);
  return <ins ref={ref} className="adsbygoogle" style={{ display: "block", width: "100%", minHeight: 600 }} data-ad-client={ADSENSE_CLIENT} data-ad-slot={slot} data-ad-format="vertical" data-full-width-responsive="false" />;
}

export function AdRail() {
  const { pathname } = useLocation();
  const { data } = useFetch("/site-settings");
  const slot = data?.ad_rail_slot;
  if (!slot || !adsAllowedOn(pathname)) return null;
  return (
    <aside className="hidden xl:block w-[160px] 2xl:w-[300px] shrink-0 pt-8 pr-4" aria-label="Advertisement" data-testid="ad-rail">
      <div className="sticky top-24">
        <p className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Advertisement</p>
        <RailUnit key={pathname} slot={slot} />
      </div>
    </aside>
  );
}
